// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DeleteDataItemRequestModel from '../../model/delete-data-item-request-model';
import DeleteDataItemRequestDTO from '../dto/delete-data-item-request-dto';
import dtoSchema from '../schemas/delete-data-item-request-schema';

export default abstract class DeleteDataItemRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DeleteDataItemRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<DeleteDataItemRequestDTO>): DeleteDataItemRequestModel;
  static toModel(dto: DeepPartial<DeleteDataItemRequestDTO> | undefined | null): DeleteDataItemRequestModel | undefined;
  static toModel(dto: DeepPartial<DeleteDataItemRequestDTO> | undefined | null): DeleteDataItemRequestModel | undefined {
    return dto ? new DeleteDataItemRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DeleteDataItemRequestModel> | DeleteDataItemRequestModel): DeleteDataItemRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as DeleteDataItemRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DeleteDataItemRequestModel, can not map to DeleteDataItemRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
